/* Kortingsbadge ("20% OFF") naast de BESTSELLER-pil op DAWN-productkaarten (Pim 10-09-2026).
   De collectie-carrousel (cc-card) doet dit sinds 12:45 puur in Liquid/CSS (labelrij), zonder dit script.
   Werkt voor de collectie-carrousel (.cc-card-img: .bj-bestseller-pill + .cc-badge--sale) en
   voor Dawn-kaarten (.card-wrapper: .bj-bestseller-pill + .card__badge .bj-sale-badge).
   Past hij niet naast de pil (smalle kaart op mobiel), dan gaat hij op dezelfde regel naar rechts.
   Zonder bestseller-pil verandert er niets: dan staat de badge gewoon linksboven. */
(function () {
  var GAP = 6, EDGE = 10;
  function place(badge) {
    var card = badge.closest('.cc-card-img') || badge.closest('.card-wrapper') || badge.closest('.card');
    if (!card) return;
    var pill = card.querySelector('.bj-bestseller-pill');
    var target = badge.closest('.card__badge') || badge;
    if (!pill) { target.style.removeProperty('left'); target.style.removeProperty('top'); target.style.removeProperty('right'); target.style.setProperty('visibility', 'visible', 'important'); return; }
    var parent = target.offsetParent || card;
    var pr = pill.getBoundingClientRect(), cr = card.getBoundingClientRect(), op = parent.getBoundingClientRect(), br = target.getBoundingClientRect();
    if (!pr.width || !br.width) return;
    var top = pr.top - op.top;
    var left = pr.left - op.left + pr.width + GAP;
    var fits = (pr.left - cr.left) + pr.width + GAP + br.width + EDGE <= cr.width;
    target.style.setProperty('top', top + 'px', 'important');
    if (fits) {
      target.style.setProperty('left', left + 'px', 'important');
      target.style.setProperty('right', 'auto', 'important');
    } else {
      target.style.setProperty('left', 'auto', 'important');
      target.style.setProperty('right', EDGE + 'px', 'important');
    }
    target.setAttribute('data-bj-aligned', fits ? 'next' : 'right');
    target.style.setProperty('visibility', 'visible', 'important');
  }
  function run() {
    var badges = document.querySelectorAll('.card__badge .bj-sale-badge');
    for (var i = 0; i < badges.length; i++) { try { place(badges[i]); } catch (e) {} }
  }
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(run, 60); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  try { new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
  window.bjSaleBadgeAlign = run;
})();
